import { Form } from './Form'
import { FormValues } from './Form/model'
import { Title } from './styled'

type ContentProps = {
  onSuccess: (formValues: FormValues) => void
  isSubmitting: boolean
}

export function Content({ onSuccess, isSubmitting }: ContentProps) {
  return (
    <div>
      <Title>Парковый ИП</Title>

      <Form onSuccess={onSuccess} isSubmitting={isSubmitting} />
    </div>
  )
}
